import { Box, Card, Stack } from "@mui/material";

import ProductBenefits from "@/components/planPricing/ProductBenefits";
import { PRICING_PLAN_CATALOG } from "@/config/pricingPlanCatalog";
import PopularPlansSelector from "./PopularPlansSelector";
import ProductPlanHeader from "./ProductPlanHeader";
import { DashboardProduct } from "./useDashboardProducts";

/**
 * The inactive-product tab content (r-1776): product header with the outlined
 * Popular Plans purchase flow, followed by the product's key benefits.
 */
export default function InactiveProductView({
  product,
}: {
  product: DashboardProduct;
}) {
  if (product.type === "free") return null;
  const catalogProduct = PRICING_PLAN_CATALOG[product.type];

  return (
    <Stack spacing={3} data-testid={`product-inactive-${product.type}`}>
      <Card sx={{ p: 3 }}>
        <Stack spacing={3}>
          <ProductPlanHeader
            icon={catalogProduct.icon}
            iconSize={40}
            title={catalogProduct.title}
            caption={catalogProduct.description}
          />
          <Box sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
            <PopularPlansSelector planKey={product.type} />
          </Box>
        </Stack>
      </Card>
      <Card sx={{ p: 3 }}>
        <ProductBenefits
          title={catalogProduct.title}
          benefits={catalogProduct.benefits}
        />
      </Card>
    </Stack>
  );
}
